var ClientConfigBuilder = /** @class */ (function () {
    function ClientConfigBuilder() {
        this.storeId = 'STORE_ID_STRING';
        this.storeCountry = 'USA';
        this.storeCurrency = 'USD';
        this.uuid = 'UUID_STRING';
        this.visitor_id = 'VISITOR_ID_STRING';
        this.ecomSessionId = false;
        this.locale = 'en';
        this.layoutDirection = 'ltr';
        this.clientVersion = 'CLIENT_VERSION_STRING';
        this.debug = true;
        this.isMerchant = false;
        this.isPremium = 'false';
        this.isPrimaryLanguage = true;
    }
    ClientConfigBuilder.prototype.withStoreId = function (storeId) {
        this.storeId = storeId;
        return this;
    };
    ClientConfigBuilder.prototype.withStoreCountry = function (storeCountry) {
        this.storeCountry = storeCountry;
        return this;
    };
    ClientConfigBuilder.prototype.withInstance = function (instance) {
        this.instance = instance;
        return this;
    };
    ClientConfigBuilder.prototype.withUuid = function (uuid) {
        this.uuid = uuid;
        return this;
    };
    ClientConfigBuilder.prototype.withVisitorId = function (visitor_id) {
        this.visitor_id = visitor_id;
        return this;
    };
    ClientConfigBuilder.prototype.withEcomSessionId = function (ecomSessionId) {
        this.ecomSessionId = ecomSessionId;
        return this;
    };
    ClientConfigBuilder.prototype.withLocale = function (locale) {
        this.locale = locale;
        return this;
    };
    ClientConfigBuilder.prototype.withClientVersion = function (clientVersion) {
        this.clientVersion = clientVersion;
        return this;
    };
    ClientConfigBuilder.prototype.withViewMode = function (viewMode) {
        this.viewMode = viewMode;
        return this;
    };
    ClientConfigBuilder.prototype.withDeviceType = function (deviceType) {
        this.deviceType = deviceType;
        return this;
    };
    ClientConfigBuilder.prototype.withDebug = function (debug) {
        this.debug = debug;
        return this;
    };
    ClientConfigBuilder.prototype.withIsMerchant = function (isMerchant) {
        this.isMerchant = isMerchant;
        return this;
    };
    ClientConfigBuilder.prototype.withIsOwner = function (isOwner) {
        this.isOwner = isOwner;
        return this;
    };
    ClientConfigBuilder.prototype.withIsPremium = function (isPremium) {
        this.isPremium = isPremium;
        return this;
    };
    ClientConfigBuilder.prototype.withIsNewCountryList = function (isNewCountryList) {
        this.isNewCountryList = isNewCountryList;
        return this;
    };
    ClientConfigBuilder.prototype.withIsNewCurrencyList = function (isNewCurrencyList) {
        this.isNewCurrencyList = isNewCurrencyList;
        return this;
    };
    ClientConfigBuilder.prototype.withIsNewLocaleList = function (isNewLocaleList) {
        this.isNewLocaleList = isNewLocaleList;
        return this;
    };
    ClientConfigBuilder.prototype.withBaseHref = function (baseHref) {
        this.baseHref = baseHref;
        return this;
    };
    ClientConfigBuilder.prototype.withLayoutDirection = function (layoutDirection) {
        this.layoutDirection = layoutDirection;
        return this;
    };
    ClientConfigBuilder.prototype.withIsPrimaryLanguage = function (value) {
        this.isPrimaryLanguage = value;
        return this;
    };
    return ClientConfigBuilder;
}());
export { ClientConfigBuilder };
export default ClientConfigBuilder;
export function aClientConfig() {
    return new ClientConfigBuilder();
}
//# sourceMappingURL=client-config.builder.js.map